import { render } from "./SectionWrapper.vue?vue&type=template&id=035047d7&scoped=true"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"

import "./SectionWrapper.vue?vue&type=style&index=0&id=035047d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035047d7"]])

export default __exports__